"use strict";
module.exports = {
    entityModel: 'supplierCustomer',
    events: {
        SUPPLIER_CUSTOMER_UPDATED: 'SUPPLIER_CUSTOMER_UPDATED',
        SUPPLIER_CUSTOMER_CREATED: 'SUPPLIER_CUSTOMER_CREATED',
        SUPPLIER_CUSTOMER_APPROVED: 'SUPPLIER_CUSTOMER_APPROVED',
        SUPPLIER_CUSTOMER_ACTIVATED: 'SUPPLIER_CUSTOMER_ACTIVATED',
        SUPPLIER_CUSTOMER_DEACTIVATED: 'SUPPLIER_CUSTOMER_DEACTIVATED',
        SUPPLIER_CUSTOMER_BLOCKED: 'SUPPLIER_CUSTOMER_BLOCKED',
        SUPPLIER_CUSTOMER_UNBLOCKED: 'SUPPLIER_CUSTOMER_UNBLOCKED',
        SUPPLIER_CUSTOMER_CONTACTS_UPDATED: 'SUPPLIER_CUSTOMER_CONTACTS_UPDATED',
        SUPPLIER_CUSTOMER_OFC_CHANGED: 'SUPPLIER_CUSTOMER_OFC_CHANGED',
        SUPPLIER_CUSTOMER_ALCOHOL_LICENSE_APPROVED: 'SUPPLIER_CUSTOMER_ALCOHOL_LICENSE_APPROVED',
        SUPPLIER_CUSTOMER_ALCOHOL_LICENSE_REVOKED: 'SUPPLIER_CUSTOMER_ALCOHOL_LICENSE_REVOKED',
    },
    actions: {
        get: 'v1.supplierCustomer.get',
        list: 'v1.supplierCustomer.list',
        setDeliveryRules: 'v1.supplierCustomer.setDeliveryRules',
        writeCustomer: 'v1.supplierCustomer.writeCustomer',
        importCustomer: 'v1.supplierCustomer.importCustomer',
        writeContact: 'v1.supplierCustomer.writeContact',
        deactivate: 'v1.supplierCustomer.deactivate',
        activate: 'v1.supplierCustomer.activate',
        removeContact: 'v1.supplierCustomer.removeContact',
        approveSupplierCustomer: 'v1.supplierCustomer.approveSupplierCustomer',
        blockSupplierCustomer: 'v1.supplierCustomer.blockSupplierCustomer',
        unblockSupplierCustomer: 'v1.supplierCustomer.unblockSupplierCustomer',
        changeOrderFullfillmentCenter: 'v1.supplierCustomer.changeOrderFullfillmentCenter',
        approveAlcoholLicense: 'v1.supplierCustomer.approveAlcoholLicense',
        revokeAlcoholLicense: 'v1.supplierCustomer.revokeAlcoholLicense',
        upsert: 'v1.supplierCustomer.upsert',
        upsertWhenEmpty: 'v1.supplierCustomer.upsertWhenEmpty',
        updateWhenEmpty: 'v1.supplierCustomer.updateWhenEmpty',
        update: 'v1.supplierCustomer.update',
    },
    deliveryCountries: {
        SE: 'SE',
        FI: 'FI',
        NO: 'NO',
        DK: 'DK',
        IS: 'IS',
    },
    customerTypes: {
        horeca: 'horeca',
        dvh: 'dvh',
        wholesale: 'wholesale',
        office: 'office',
        systembolaget: 'systembolaget',
        supplier: 'supplier',
        export: 'export',
        other: 'other',
    },
    invoiceDeliveryTypes: {
        PRINT: 'PRINT',
        EMAIL: 'EMAIL',
        ELECTRONICINVOICE: 'ELECTRONICINVOICE',
    },
    invoiceCountries: {
        SE: 'SE',
        FI: 'FI',
        NO: 'NO',
        DK: 'DK',
        IS: 'IS',
    },
    termsOfPayments: {
        0: '0',
        10: '10',
        15: '15',
        20: '20',
        30: '30',
        35: '35',
        60: '60',
        70: '70',
        A: 'A',
        K: 'K',
        PF: 'PF',
    },
    supplierCustomerContacts: {},
};
